export default {
  model (resource) {
    return Object.assign({
      title: null,
      description: null,
      dueDate: null,
      reminder: false,
      opportunityId: null
    }, resource)
  },
  rules () {
    return {
      title: [
        {required: true, message: 'El título es requerido'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/tasks/tasks.model.js